export type KeyboardShortcut = {
  modifierKey: ModifierKey | null;
  shortcutKey: string;
};

export type ModifierKey = 'command' | 'shift';

export const COMMAND_ENTER_SHORTCUT: KeyboardShortcut = { modifierKey: 'command', shortcutKey: 'enter' };

export const modifierKeyPrefix = () => {
  // It's okay to use navigator.platform to determine which modifier key to recommend.
  // https://developer.mozilla.org/en-US/docs/Web/API/Navigator/platform#examples
  const isMac = navigator.platform.indexOf('Mac') === 0 || navigator.platform === 'iPhone';
  return isMac ? '⌘' : '^';
};

/**
 * Formats a keyboard shortcut for display in the UI.
 * @returns The string to be displayed in the UI.
 */
export function formatKeyboardShortcut(ks: KeyboardShortcut): string {
  const { modifierKey, shortcutKey } = ks;

  let prefix;

  if (modifierKey === 'shift') {
    prefix = 'SHIFT +';
  } else if (modifierKey === 'command') {
    prefix = modifierKeyPrefix();
  }

  if (prefix) {
    return `${prefix} ${shortcutKey.toUpperCase()}`;
  } else {
    return shortcutKey.toUpperCase();
  }
}
